import { render, staticRenderFns } from "./ListagemVoxuy.vue?vue&type=template&id=c5e550ec&scoped=true&"
import script from "./ListagemVoxuy.vue?vue&type=script&lang=js&"
export * from "./ListagemVoxuy.vue?vue&type=script&lang=js&"
import style0 from "./ListagemVoxuy.vue?vue&type=style&index=0&id=c5e550ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e550ec",
  null
  
)

export default component.exports